import React from 'react';
import ChartWithAnnotations from './ChartWithAnnotations';

class LineChartWithAnnotations extends React.Component {
    render(){
        return <ChartWithAnnotations chartType="line" {...this.props} />    
    }
    
}
export default LineChartWithAnnotations